export const COUNTRY_CODES = [
  { code: "91", label: "India (+91)" },
  { code: "1", label: "United States (+1)" },
  { code: "44", label: "United Kingdom (+44)" },
  { code: "61", label: "Australia (+61)" },
  { code: "971", label: "United Arab Emirates (+971)" },
  { code: "81", label: "Japan (+81)" },
  { code: "49", label: "Germany (+49)" },
  { code: "33", label: "France (+33)" },
  { code: "65", label: "Singapore (+65)" },
  { code: "60", label: "Malaysia (+60)" },
  { code: "64", label: "New Zealand (+64)" },
  { code: "966", label: "Saudi Arabia (+966)" },
  { code: "974", label: "Qatar (+974)" },
  { code: "968", label: "Oman (+968)" },
  { code: "973", label: "Bahrain (+973)" },
];
